/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {captureThreatmetrixSession} from '../api'

export const useMutationCaptureThreatmetrixSession = createReactQueryMutationHook('captureThreatmetrixSession', captureThreatmetrixSession)
